import api, { ApiResponse } from './api';

import { Voltage } from 'entities/Voltage';

interface GetVoltageListResponse {
  success: boolean;
  data: Voltage[];
}

export const getVoltageListService = (): ApiResponse<GetVoltageListResponse> =>
  api({
    method: 'GET',
    url: 'voltages',
    useToken: true,
  });
